import React, { Component, lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import PageLoading from './common/PageLoading';
import Header from './common/Header';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import ApplicationAccessDenied from './authentication/ApplicationAccessDenied';
import { SessionProvider } from './session/SessionContext';

const AdminRoutes = lazy(() => import(/* webpackChunkName: "admin-routes" */ './admin/AdminRoutes'));
const Authentication = lazy(() => import(/* webpackChunkName: "authentication" */ './authentication/Authentication'));

class App extends Component {
  render() {
    return (
      <SessionProvider>
        <ThemeProvider theme={theme}>
          <div className="App">
            <Header />

            <BrowserRouter>
              <Suspense fallback={<PageLoading />}>
                <Routes>
                  <Route path="/" element={<Authentication />} />
                  <Route path="/application-access-denied" element={<ApplicationAccessDenied />} />
                  <Route path="/admin/*" element={<AdminRoutes />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>
            </BrowserRouter>
          </div>
        </ThemeProvider>
      </SessionProvider>
    );
  }
}

export default App;
